import {CardContent, CardHeader, Chip} from "@mui/material";
import Grid from "@mui/material/Grid/Grid";
import {Filter, RadioGroup, SpringPageable} from "@variocube/app-ui";
import React from "react";
import {BookingShareQuery} from "../../../api/bookingShare";
import {useLocalization} from "@smalox/shared";

export type BookingShareFilter = Omit<BookingShareQuery, keyof SpringPageable>;

export interface BookingShareFilterProps {
	value: BookingShareFilter;
	onChange: (value: BookingShareFilter) => any;
}

export function BookingShareFilter({value, onChange}: Readonly<BookingShareFilterProps>) {
	const {t, s} = useLocalization();

	return (
		<Filter
			label={t("filter.title")}
			active={[
				value.status && (
					<Chip
						key={"status"}
						label={t(`bookings.shares.status.${value.status}`)}
						onDelete={() => onChange({...value, status: undefined})}
					/>
				),
			]}
			labels={s("filter")}
		>
			<CardContent>
				<Grid container spacing={2}>
					<Grid item xs={12} sm={6} md={4}>
						<CardHeader title={t("bookings.shares.status.title")} />
						<CardContent>
							<RadioGroup
								value={value.status ?? "all"}
								onChange={status => onChange({...value, status: status == "all" ? undefined : status})}
								options={["all", "ACTIVE", "EXPIRED"]}
								renderLabel={s("bookings.shares.status")}
							/>
						</CardContent>
					</Grid>
				</Grid>
			</CardContent>
		</Filter>
	);
}
